// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBTUBXxNGGCI18eaE0N54fnxF939S__Dfo",
  authDomain: "kacha-bazar-58a17.firebaseapp.com",
  projectId: "kacha-bazar-58a17",
  storageBucket: "kacha-bazar-58a17.appspot.com",
  messagingSenderId: "103978891752",
  appId: "1:103978891752:web:b2cec146f03eb4c2690c5d"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app;